import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Subscription } from 'rxjs';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { LanguageValues, ServiceDetails, ServiceViewModel } from '../../../business-entities/service-view-model';
import { ServicesService } from '../../../business-services/services.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { SecureStorage } from './../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { BrandService } from '../../../business-services/brand.service';
import { BrandType, VehicleType } from '../../../business-entities/vehicle-list-view-model';
import { FuelTypeForMultiselect, ServiceFilterViewModel, ServiceTimeDetailViewModel } from '../../../business-entities/ServiceFilter-viewModel';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { SpecialToolBusinessService } from '../../../business-services/special-tool.service';
import { SpecialToolType } from '../../../business-entities/special-tool-model';
import { WarningLightService } from '../../../business-services/warninglight.service';
import { WarningLightListModel } from '../../../business-entities/warning-light-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { PackageDropdownList } from '../../../business-entities/package-list-model';
import { PackageService } from '../../../business-services/package.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { LaborService } from '../../../business-services/labor.service';
@Component({
  selector: 'app-edit-service',
  templateUrl: './edit-service.component.html'
})

export class EditServiceComponent implements OnInit, OnDestroy {

  ServiceInfo: ServiceDetails;
  id: number;
  editServices = false;
  editServiceForm: FormGroup;
  response: any;
  categoryList: any;
  competenceList: any;
  competenceActiveList: any = [];
  image: string | ArrayBuffer;
  Language: any[];
  currentlagSub: Subscription;
  imageBaseData: string | ArrayBuffer = null;
  serviceTimeDetailData: any;
  dropdownSettings = {};
  serviceDetails: ServiceTimeDetailViewModel
  ServiceFilterForm: ServiceFilterViewModel[] = []
  allServices: ServiceViewModel[] = [];
  makeList: BrandType[] = [];
  vehicleTypes: VehicleType[] = [];
  fuels: FuelType[] = [];
  selectedChildServices: any[] = [];
  selectedChildServicesString: string = '';
  deletedServiceFilterId: string = '';
  selectedChecklists: any[] = []
  VehicleAge = [];
  Mileage = [];
  LogicOperator = [];
  checkList: any[] = [];
  checkListSelected: any = null;
  imageToDelete: boolean = false;
  fileName: string = '';
  features: Features[] = [];
  specialToolTypes: SpecialToolType[] = [];
  showspecialtool: boolean = false;
  allWarningLight: WarningLightListModel[] = [];
  selectedWarningLight: any[] = [];
  selectedWarningLightString: string = '';
  dropdownSettingsWarningLight = {};
  isWarningLightFeature: boolean = false;
  integrationWithDms: boolean = false;
  realTimeDmsSyncService: boolean = false;
  packageDropdownList: PackageDropdownList[] = [];
  selectPackage: string = '';
  VATPercentage:number=0;
  isAddView:boolean = false;
  dmsServiceId:boolean=false;
  popupCloseResult = false;
  popupDisplay = false;
  chargingGroupList:any;
  chargingGroup:any;
  constructor(private EditService: ServicesService,  
    private formBuilder: FormBuilder,
    private secureStorage: SecureStorage, private spinner: NgxSpinnerService,
    private toaster: ToastrService, private translate: TranslateService,
    private currentLanguageService: CurrentLanguage, private cookieservice: CookieService,
    private globalSetting: GlobalSetting, private cultureLocaleService: CultureLocaleService,
    private activeModal: NgbActiveModal,
    private brandService: BrandService,
    private checkListService: CheckListBusinessService,
    private EditRentalCar: RentalCarService,
    private cdr: ChangeDetectorRef,
    private specialToolService: SpecialToolBusinessService,
    private warningLightService: WarningLightService,
    private imageService: ImageService,
    private laborService: LaborService,
    private modalService: NgbModal,
    private packageService: PackageService) {
    this.Mileage = Constant.Mileage;
    this.VehicleAge = Constant.VehicleAge;
    this.LogicOperator = Constant.LogicOperator;
  }

  ngOnInit(): void {
    this.VATPercentage = this.secureStorage.getKeyData('VATPercentage');
    this.features = this.secureStorage.getKeyData('feature');
    if ((this.features != null || this.features != undefined) && this.features.length > 0) {
      this.integrationWithDms = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      this.realTimeDmsSyncService = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSS)?.isActive;
      this.isWarningLightFeature = this.features.find(x => x.featureCode === Enums.FeatureCode.WarningLight)?.isActive;
      this.showspecialtool = this.features.find(x => x.featureCode === Enums.FeatureCode.SpecialTool)?.isActive;
      this.dmsServiceId = this.features.find(x => x.featureCode === Enums.FeatureCode.DMSService)?.isActive;
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'childService',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500
    };

    this.dropdownSettingsWarningLight = {
      singleSelection: false,
      idField: 'id',
      textField: 'warningName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false,
      maxHeight: 500
    };
    this.serviceDetails = {
      makeList: null,
      modelList:null,
      vehicleTypes: null,
      fuels: null,
      vehicleAge: null,
      mileage: null,
      logicOperator: null

    }
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.Language = this.currentLanguageService.LanguageList;
    const routeServiceId = this.EditService.serviceId;
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.GetAll(routeServiceId);
    });
    this.editServiceForm = this.formBuilder.group({
      service: new FormArray([]),
      price: [0, [Validators.required]],
      priceInclVAT: [0, [Validators.required]],
      duration: [0, [Validators.required]],
      serviceNo: ['', [Validators.required]],
      //logo: ['',],
      Image: [''],
      ImageBinaryData: [''],
      MimeType: [''],
      //serviceCategoryName:[''],
      serviceCategoryId: [''],
      serviceExternalink:[''],
      competenceId: [''],
      // competenceName: [''],
      isActive: [''],
      displayInWidget: [''],
      displayPriceInWidget: [''],
      isServiceChecked: [false],
      isFixed: [''],
      id: [0],
      widgetSequence: [''],
      plannerSequence: [''],
      isAdditionalCustomerComment: [false],
      additionalCustomerComment: new FormArray([]),
      needAttention: [''],
      specialToolTypeId: [''],
      dmsServiceId: [''],
      isWarningLight: [false],
      packageNo: [''],
      chargingGroup:['']
    });
    this.serviceDetails.logicOperator = this.LogicOperator;
    this.serviceDetails.vehicleAge = this.VehicleAge;
    this.serviceDetails.mileage = this.Mileage;
    this.editServiceForm.controls['chargingGroup'].disable();
    this.getLanguage();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  get cpf() {
    return this.editServiceForm.controls;
  }

  get t() { return this.cpf.service as FormArray; }

  get c() { return this.cpf.additionalCustomerComment as FormArray; }

  private alignToLanguages(details: LanguageValues[]): LanguageValues[] {
    return this.Language.map(lang =>
      (details ?? []).find(x => x.languageId == lang.id)
      ?? { languageId: lang.id, name: '', description: '', internalDescription: '' });
  }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['',],
          name: ['', Validators.required],
          description: ['', Validators.required],
          internalDescription: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }


    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['',],
          name: ['',],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }
  }
  RemoveLogo() {
    this.editServiceForm.value.Image = "";
    this.editServiceForm.value.ImageBinaryData = "";
    this.ServiceInfo.serviceDetails[0].logo = "";
    this.image = "";
    if (this.fileName) {
      this.imageToDelete = true;
    }
  }
  async GetAll(routeServiceId) {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
    this.EditService.getServiceCategory(language).then(response => {
      let data = response.responseObject;
      this.categoryList = data;
    })
    this.EditService.getDiagnoseCheckListForService(language).then(response => {
      let data = response.responseObject;
      this.checkList = data.filter(x => x.serviceId != this.EditService.serviceId);
      this.selectedChecklists = data.filter(x => x.serviceId == this.EditService.serviceId)
      this.selectedChecklists.forEach(element => {
        while (this.checkList.findIndex(x => x.id == element.id) != -1) {
          this.checkList.splice(this.checkList.findIndex(x => x.id == element.id), 1);
        }
      })
      this.checkList = this.checkList.filter((x, index) => this.checkList.findIndex(ele => ele.id == x.id) === index)
    })
    await this.getCompetence(0);
    for (let item of this.competenceList) {
      if (item.isActive) {
        this.competenceActiveList.push(item);
      }
    }
    await this.getAllServices();
    await this.GetAllMake();
    await this.GetAllVehicleTypes();
    await this.GetAllFuelTypes();
    this.showspecialtool && await this.GetAllSpecialToolTypes();
    if (this.isWarningLightFeature) {
      await this.GetWarningLight();
    }
    await this.getPackages();
    this.getActiveServiceList(routeServiceId);
  }

  async getPackages() {
    this.spinner.show();
    let model = {
      makeCode: "",
      cultureCode: this.cookieservice.get('userSelectedLanguage'),
    }
    await this.packageService.getAfxPackageDropdown(model).then(response => {
      this.packageDropdownList = response?.responseObject;
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }
  async GetWarningLight() {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.warningLightService.getWarningLightDropDown(language)
      .then((response) => {
        this.allWarningLight = response;
      });
  }

  async getAllServices() {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.EditService.getService(language, 1, true)
    .then((response) => {
      let serviceId =this.EditService.serviceId;
      this.allServices = response.filter(x => x.id !== serviceId && !x.childServiceId?.split(',').includes(serviceId.toString()));
      this.allServices.forEach((service)=>{
        service.childService = service.serviceNo + " - "+ service.name
        })
      });
  }

  async GetAllMake(): Promise<void> {
    await this.brandService.GetBrandDropdown().then(data => {
      this.makeList = data.responseObject;
      this.serviceDetails.makeList = this.makeList;
    });
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      this.serviceDetails.vehicleTypes = this.vehicleTypes;
    });
  }

  async GetAllFuelTypes(): Promise<void> {
    await this.EditRentalCar.GetFuelTypes().then(data => {
      this.fuels = data.responseObject.result.slice();
      this.serviceDetails.fuels = this.MapFuelType(this.fuels);
    });
  }
  async GetAllSpecialToolTypes(): Promise<void> {
    await this.specialToolService.getAllSpecialToolTypes().then(data => {
      this.specialToolTypes = data.responseObject
    });
  }
  MapFuelType(fuelList: FuelType[]) {
    let fuels: FuelTypeForMultiselect[] = [];
    fuelList.forEach(element => {
      let fuelDetail: FuelTypeForMultiselect =
      {
        id: element.id,
        fuelType: element.fuelType,
        description: element.description,
        fuelCodeAndType: element.fuelType + ' - ' + element.description
      }
      fuels.push(fuelDetail);
    });
    return fuels;
  }

  async getCompetence(status: number) {
    await this.EditService.getCompetence(status).then(resp => {
      this.competenceList = resp.responseObject;
    })
  }

  ngOnDestroy(): void {
    this.secureStorage.removeKey('ServiceId');
    this.currentlagSub.unsubscribe();
  }

  addChecklist() {
    if (this.checkListSelected != null) {
      let Obj = {
        id: this.checkListSelected,
        subCheckListTitle: this.checkList.filter(x => x.id == this.checkListSelected)[0].subCheckListTitle,
        serviceId: this.EditService.serviceId
      }
      this.selectedChecklists.push(Obj);
      this.checkList.splice(this.checkList.findIndex(x => x.id == this.checkListSelected), 1);
      this.checkListSelected = null;
    }
  }
  removeChecklist(i, item) {
    this.selectedChecklists.splice(i, 1);
    this.checkList.push(item);
  }
  private getActiveServiceList(Id: number) {
    this.spinner.show();
    this.EditService.GetServiceById(Id).then(result => {
      this.ServiceInfo = result;
      this.ServiceInfo.serviceLanguageDetails = this.alignToLanguages(result.serviceLanguageDetails);
      this.ServiceInfo.customerCommentLanguageDetails = this.alignToLanguages(result.customerCommentLanguageDetails);
      this.popupDisplay = this.ServiceInfo.serviceDetails[0].isActive;
        this.ServiceInfo.serviceDetails[0].duration = Utility.ConvertMinutesToTime(this.ServiceInfo.serviceDetails[0].duration);
        this.isAddView = this.ServiceInfo.serviceDetails[0]?.isFixed ?? false;
      this.image = this.ServiceInfo.serviceDetails[0].logo;
      if (this.image) {
        this.fileName = this.ServiceInfo.serviceDetails[0]?.fileName;
      }
      this.editServiceForm.controls["Image"].setValue(this.ServiceInfo.serviceDetails[0].logo);
      this.editServiceForm.controls["competenceId"].setValue(this.ServiceInfo.serviceDetails[0].competenceId);
      this.editServiceForm.controls["serviceCategoryId"].setValue(this.ServiceInfo.serviceDetails[0].serviceCategoryId);
      this.editServiceForm.controls["serviceExternalink"].setValue(this.ServiceInfo.serviceDetails[0].serviceExternalink);
      this.editServiceForm.controls["widgetSequence"].setValue(this.ServiceInfo.serviceDetails[0].widgetSequence);
      this.editServiceForm.controls["plannerSequence"].setValue(this.ServiceInfo.serviceDetails[0].plannerSequence);
      this.editServiceForm.controls["serviceNo"].setValue(this.ServiceInfo.serviceDetails[0].serviceNo);
      this.editServiceForm.controls["isAdditionalCustomerComment"].setValue(this.ServiceInfo.serviceDetails[0].isAdditionalCustomerComment)
      this.editServiceForm.controls["dmsServiceId"].setValue(this.ServiceInfo.serviceDetails[0].dmsServiceId)
      this.editServiceForm.controls["specialToolTypeId"].setValue(this.ServiceInfo.serviceDetails[0].specialToolTypeId);
      this.editServiceForm.controls["packageNo"].setValue(this.ServiceInfo.serviceDetails[0].selectPackage);
      this.selectPackage = this.ServiceInfo.serviceDetails[0].selectPackage;

      this.GetServiceTimeDetails(Id);
      this.MapChildService();
      if (this.ServiceInfo.serviceDetails[0].isWarningLight && this.isWarningLightFeature) {
        this.MapWarningLight();
      }
      this.getChargingGroupDropDown();

      this.cdr.detectChanges();
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }
  GetServiceTimeDetails(Id: number) {
    this.spinner.show();
    this.EditService.GetServiceTimeDetails(Id).then(result => {
      this.serviceTimeDetailData = result;
      this.MapServiceFilterFormValue();
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  MapServiceFilterFormValue() {
    this.serviceTimeDetailData.forEach((element, index) => {
      let serviceFilterViewModel: ServiceFilterViewModel = {
        Id: 0,
        BrandId: null,
        VehicleTypeId: null,
        FuelTypeId: [],
        FuelId: '',
        RangeFunctionForVehicleAge: 0,
        VehicleAge: null,
        LogicFunction: 0,
        Mileage: null,
        RangeFunctionForMileage: 0,
        Duration: null,
        Price: null,
        PriceInclVAT: null,
        IsFixedPrice: false,
        IsShowPrice: false,
        Discount: null,
        Model:null
      };
      this.ServiceFilterForm.push(serviceFilterViewModel);
      this.ServiceFilterForm[index].Id = element.id;
      this.ServiceFilterForm[index].BrandId = element.brandId;
      this.ServiceFilterForm[index].VehicleTypeId = element.vehicleTypeId;
      this.MapFuelTypeId(element.fuelId, this.ServiceFilterForm[index]);
      this.ServiceFilterForm[index].FuelId = element.fuelId;
      this.ServiceFilterForm[index].RangeFunctionForVehicleAge = element.rangeFunctionForVehicleAge;
      this.ServiceFilterForm[index].VehicleAge = element.vehicleAge;
      this.ServiceFilterForm[index].LogicFunction = element.logicFunction;
      this.ServiceFilterForm[index].Mileage = element.mileage;
      this.ServiceFilterForm[index].RangeFunctionForMileage = element.rangeFunctionForMileage;
      this.ServiceFilterForm[index].Duration = element.duration;
      this.ServiceFilterForm[index].Price = element.price;
      this.ServiceFilterForm[index].PriceInclVAT = element.priceInclVAT;
      this.ServiceFilterForm[index].IsFixedPrice = element.isFixedPrice;
      this.ServiceFilterForm[index].IsShowPrice = element.isShowPrice;
      this.ServiceFilterForm[index].Discount = element.discount;
      this.ServiceFilterForm[index].Model = element.model
    });
    if (this.serviceTimeDetailData.length === 0) {
      let serviceFilterViewModel: ServiceFilterViewModel = {
        BrandId: null,
        VehicleTypeId: null,
        FuelTypeId: [],
        FuelId: '',
        RangeFunctionForVehicleAge: 0,
        VehicleAge: null,
        LogicFunction: 0,
        Mileage: null,
        RangeFunctionForMileage: 0,
        Duration: null,
        Price: null,
        PriceInclVAT: null,
        IsFixedPrice: false,
        IsShowPrice: false,
        Discount: null,
        Model:null
      };
      this.ServiceFilterForm.push(serviceFilterViewModel);
    }
  }

  MapChildService() {
    if (this.ServiceInfo.serviceDetails[0].childServices) {
      let childservices = this.ServiceInfo.serviceDetails[0].childServices.split(',');
      if (this.allServices && childservices) {
        this.allServices.forEach(x => {
          childservices.forEach(y => {
            if (x.id == parseInt(y)) {
              if (this.selectedChildServices.find((test) => test.id === x.id) === undefined) {
                this.selectedChildServices.push(x);
              }
            }
          })
        })
      }
    }

  }

  MapWarningLight() {
    if (this.ServiceInfo.serviceDetails[0].warningLightId) {
      let warningLightId = this.ServiceInfo.serviceDetails[0].warningLightId.split(',');
      if (this.allWarningLight && warningLightId) {
        this.allWarningLight.forEach(x => {
          warningLightId.forEach(y => {
            if (x.id == parseInt(y)) {
              if (this.selectedWarningLight.find((test) => test.id === x.id) === undefined) {
                this.selectedWarningLight.push(x);
              }
            }
          })
        })
      }
    }
  }

  MapFuelTypeId(fuelId: string, serviceFilter: ServiceFilterViewModel) {
    let fuelIds = fuelId.split(',');
    if (this.serviceDetails.fuels && fuelIds) {
      this.serviceDetails.fuels.forEach(x => {
        fuelIds.forEach(y => {
          if (x.id == parseInt(y)) {
            serviceFilter.FuelTypeId.push(x);
          }
        })
      })
    }
  }

  onBlur(event) {
    this.ServiceInfo.serviceDetails[0].price = event.target.value;
    let price = JSON.parse(JSON.stringify(event.target.value));
    this.ServiceInfo.serviceDetails[0].priceInclVAT = Utility.GetPriceInludingVAT(price, this.VATPercentage).toString();
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  IsDisplayPopup(){
    const IsActiveCheck = document.getElementById('isActive') as HTMLInputElement;
    if(IsActiveCheck.checked !== this.popupDisplay){     
      let modelHeadermsg = this.translate.instant("lblConfirmation");
      let modelBodymsg;
      if(IsActiveCheck.checked){
        modelBodymsg = this.translate.instant("lblServiceActiveConfirmation");
      }
      else{
        modelBodymsg = this.translate.instant("lblServiceDeActiveConfirmation");
      }
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then((_result)=>{
    
      }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult){
          this.EditServiceDetail();
        }
      })
    }
    else{
      this.EditServiceDetail();

    }
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  
EditServiceDetail() {
  const duration = Utility.ConvertTimeToMinutes(this.editServiceForm.value.duration);
  if (duration > 1200) {
    this.toaster.error(this.translate.instant("lblExceedDurationtimelimit"));
    return;
  }
  let customerCommentlable: any = [];
  if (this.validateAdditionalCustomerComment()) {
    return;
  }

  if (this.validateDiscount()) {
    return;
  }

   this.selectedChildServicesString = this.selectedChildServices.map(element => element.id).join(',');
   if (this.ServiceInfo.serviceDetails[0].isWarningLight && this.isWarningLightFeature) {
    if (this.selectedWarningLight.length === 0) {
      let errormsg = this.translate.instant("lblSelectWarningLight");
      this.toaster.error(errormsg);
      return;
    }
    this.selectedWarningLightString = this.selectedWarningLight.map(element => element.id).join(',');
  }
  this.ServiceFilterForm = this.ServiceFilterForm.filter((service) => service.Duration != null || service.Price != null || service.PriceInclVAT != null);
 
  let viewModel = {
          Lnlnvalue: this.editServiceForm.value.service,
          Price: this.globalSetting.getFormattedprice(this.editServiceForm.value.price),
          Duration: duration,
          Id: this.EditService.serviceId,
          IsActive: this.ServiceInfo.serviceDetails[0].isActive,
          MimeType: this.editServiceForm.value.MimeType ? this.editServiceForm.value.MimeType : "",
          Image: this.editServiceForm.value.MimeType ? this.editServiceForm.value.Image : "",
          ImageBinaryData: this.editServiceForm.value.ImageBinaryData ? this.editServiceForm.value.ImageBinaryData : "",
          DisplayInWidget: this.ServiceInfo.serviceDetails[0].displayInWidget,
          DisplayPriceInWidget: this.ServiceInfo.serviceDetails[0].displayPriceInWidget,
          ServiceCategoryId: this.editServiceForm.controls['serviceCategoryId'].value,
          ServiceExternalink: this.editServiceForm.controls['serviceExternalink'].value,
          IsFixed: this.ServiceInfo.serviceDetails[0].isFixed,
          CompetenceId: this.editServiceForm.controls['competenceId'].value,
          widgetSequence: this.editServiceForm.value.widgetSequence,
          plannerSequence: this.editServiceForm.value.plannerSequence,
          ServiceNo: this.editServiceForm.value.serviceNo,
          ServiceFilterList: this.ServiceFilterForm,
          DeletedServiceFilterList: this.deletedServiceFilterId,
          ChildServices: this.selectedChildServicesString,
          IsAdditionalCustomerComment: this.editServiceForm.value.isAdditionalCustomerComment,
          AdditionalCustomerCommentlnvalue: this.editServiceForm.value.isAdditionalCustomerComment ? this.editServiceForm.value.additionalCustomerComment : [],
          NeedAttention: this.ServiceInfo.serviceDetails[0].needAttention,
          RecommendedService: this.ServiceInfo.serviceDetails[0].recommendedService,
          IntegrationWithDms: this.integrationWithDms,
          RealTimeDmsSyncService: this.realTimeDmsSyncService,
          ChecklistMappingIds: this.selectedChecklists.map(x => x.id).join(','),
          ImageToDelete: this.imageToDelete,
          FileToDelete: this.fileName,
          SpecialToolTypeId: this.editServiceForm.controls['specialToolTypeId'].value,
          DmsServiceId: this.editServiceForm.value.dmsServiceId,
          IsWarningLight: this.ServiceInfo.serviceDetails[0].isWarningLight,
          WarningLightId: this.selectedWarningLightString,
          AFxPackageNo: '',
          AfxPackageVersionNo: 0,
          AfxPackageMakeCode: '',
          ChargingGroupCode : this.editServiceForm.controls['chargingGroup'].value
        }
        if (!this.empty(this.editServiceForm.value.packageNo)) {
          let packageObj = this.packageDropdownList.find(f => f.selectPackage == this.editServiceForm.value.packageNo)
          viewModel.AFxPackageNo = packageObj.packageNo;
          viewModel.AfxPackageVersionNo = packageObj.packageVersionNo;
          viewModel.AfxPackageMakeCode = packageObj.makeCode;
        };
  
  this.spinner.show();
  this.EditService.AddUpdateService(viewModel)
    .then(res => this.handleResponse(res))
    .catch(error => this.handleError(error))
    .finally(() => {
      this.spinner.hide();
  });
}

validateAdditionalCustomerComment() {
  if (this.editServiceForm.value.isAdditionalCustomerComment) {
    const isError = this.editServiceForm.value.additionalCustomerComment.some(element => !element.name);
    if (isError) {
      this.toaster.error(this.translate.instant("lblPleaseProvideMandatoryValue"));
      return true;
    }
  }
  return false;
}
validateDiscount() {
  const isDiscountError = this.ServiceFilterForm?.some(elementOne => {
    if (elementOne.Discount !== null) {
      elementOne.Discount = +elementOne.Discount;
      elementOne.Discount = (elementOne.Discount === 0) ? null : elementOne.Discount;
      return (+elementOne.Discount > 100 || +elementOne.Discount < 0);
    }
    return false;
  });

  if (isDiscountError) {
    this.toaster.error(this.translate.instant("lblDiscountBetween1to100"));
    return true;
  }

  return false;
}
updateServiceFilterForm() {
  if (this.ServiceFilterForm?.[0].Price > 0 && this.ServiceFilterForm?.[0].Duration > 0) {
    this.ServiceFilterForm?.forEach(elementOne => {
      elementOne.Price = this.globalSetting.getFormattedprice(elementOne.Price.toString());
      elementOne.FuelTypeId?.sort((a, b) => (a.id > b.id ? 1 : -1));
      elementOne.FuelId = elementOne.FuelTypeId.map(elementTwo => elementTwo.id).join(',');
    });
  } else {
    this.ServiceFilterForm = null;
  }
}

handleError(error) {
  this.spinner.hide();
  if (error.status === Constant.BadRequest) {
    this.toaster.warning(this.translate.instant("lblErrorWarningForValue"));
  } else {
    const errorMessage = this.translate.instant("lblServiceDetailsAreNotEdited");
    this.toaster.error(errorMessage);
  }
}
  handleResponse(res){
    let successMessage = this.translate.instant("lblServiceDetailsAreEdited");
    let errorMessage = this.translate.instant("lblServiceDetailsAreNotEdited");
    if (res.responseCode === Constant.SuccessResponseCode) {
      if (res.responseObject.isSuccess) {
        localStorage.setItem('lastService', JSON.stringify(this.ServiceInfo));
        this.toaster.success(successMessage);
        this.activeModal.close({ success: true });
        return;
      }
  
      let errormsg = this.translate.instant(
        res.responseObject.retValue === '-8000' ? 'lblAlreadyAddedService' : 'lblInternalError'
      );
      this.toaster[res.responseObject.retValue === '-8000' ? 'warning' : 'error'](errormsg);
    } else if (res.responseCode === Constant.ResponseCode) {
      let errormsg = this.translate.instant('lblAlreadyExistServiceName');
      this.toaster.warning(errormsg);
    } else {
      this.toaster.error(errorMessage);
    }
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.editServiceForm.controls["MimeType"].setValue(files[0].type);
    this.editServiceForm.controls["Image"].setValue(files[0].name);
    let imageSize = files[0].size;
    let imgerrormsg = this.translate.instant("lblAllowedJPGPNGSVG");
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat = this.imageService.validateImageFormat(this.editServiceForm.value.MimeType);
    if (isValidFormat) {
      if (imageSize < 100000) {
        reader.onload = (_readerEvent) => {
          this.ServiceInfo.serviceDetails[0].logo = "";
          me.imageBaseData = reader.result;
          this.editServiceForm.value.ImageBinaryData = reader.result.toString().replace('data:' + this.editServiceForm.value.MimeType + ';base64,', '');
          this.image = me.imageBaseData;
        };
        if (this.fileName) {
          this.imageToDelete = true;
        }
      }
      else {
        let errormsg = this.translate.instant("lblSizeExceedError");
        this.toaster.error(errormsg);
      }
    }
    else {
      this.toaster.error(imgerrormsg);
    }
    reader.onerror = function (_error) {
      // This is intentional
    };
  }


  public onChangeIsActive(_value: boolean) {
    this.ServiceInfo.serviceDetails[0].isActive = !this.ServiceInfo.serviceDetails[0].isActive;
  }
  public onChangedisplayInWidget(_value: boolean) {
    this.ServiceInfo.serviceDetails[0].displayInWidget = !this.ServiceInfo.serviceDetails[0].displayInWidget;
    if (!this.ServiceInfo.serviceDetails[0].displayInWidget) {
      this.ServiceInfo.serviceDetails[0].displayPriceInWidget = false;
    }
  }
  public onChangeIsFixed(value: any) {
    this.ServiceInfo.serviceDetails[0].isFixed = !value;
    this.isAddView = (!value) ? true : false;
  }
  public onChangeNeedAttention(_value: any) {
    this.ServiceInfo.serviceDetails[0].needAttention = !this.ServiceInfo.serviceDetails[0].needAttention;
  }
  public onChangeRecommendedService(_value: any) {
    this.ServiceInfo.serviceDetails[0].recommendedService = !this.ServiceInfo.serviceDetails[0].recommendedService;
  }

  public onChangeIsWarningLight(_value: any) {
    this.ServiceInfo.serviceDetails[0].isWarningLight = !this.ServiceInfo.serviceDetails[0].isWarningLight;
    if (!this.ServiceInfo.serviceDetails[0].isWarningLight) {
      this.selectedWarningLight = [];
      this.selectedWarningLightString = '';
    }
  }

  public onChangedisplayPriceInWidget(_value: boolean) {
    this.ServiceInfo.serviceDetails[0].displayPriceInWidget = !this.ServiceInfo.serviceDetails[0].displayPriceInWidget;
  }

  public selectedCategory(value: any) {
    this.ServiceInfo.serviceDetails[0].serviceCategoryId = value;
  }

  public selectedCompetence(value: any) {
    this.ServiceInfo.serviceDetails[0].competenceId = value;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  CheckDuration(event) {
    if (event.inputType != 'deleteContentBackward') {
      if ((this.ServiceInfo.serviceDetails[0].duration).toString().length == 2) {
        this.editServiceForm.patchValue({
          duration: this.ServiceInfo.serviceDetails[0].duration + ':',
        })
      }
    }
  }


  OnClose() {
    this.activeModal.close({ success: true })
  }

  AddServiceFilter(_index: number) {
    let serviceFilterViewModel: ServiceFilterViewModel = {
      BrandId: null,
      VehicleTypeId: null,
      FuelTypeId: [],
      FuelId: '',
      RangeFunctionForVehicleAge: 0,
      VehicleAge: null,
      LogicFunction: 0,
      Mileage: null,
      RangeFunctionForMileage: 0,
      Duration: null,
      Price: null,
      PriceInclVAT: null,
      IsFixedPrice: false,
      IsShowPrice: false,
      Discount: null,
      Model:null
    };
    this.ServiceFilterForm.push(serviceFilterViewModel);
  }

  RemoveServiceFilter(index: number) {
    if (this.ServiceFilterForm[index]?.Id) {
      this.deletedServiceFilterId += this.ServiceFilterForm[index].Id + ',';
    }
    this.ServiceFilterForm.splice(index, 1);
    if (this.ServiceFilterForm.length === 0) {
      this.AddServiceFilter(0);
    }
  }

  onChildServiceSelected(serviceId: any): void {
    if (serviceId == null) {
      this.selectedChildServices = [];
    } else {
      if (serviceId.length == 0) {
        this.selectedChildServices = [];
      }
    }
  }

  onWarningLightSelected(Id: any): void {
    if (Id == null) {
      this.selectedWarningLight = [];
    } else {
      if (Id.length == 0) {
        this.selectedWarningLight = [];
      }
    }
  }
  async getChargingGroupDropDown() {
    this.spinner.show();
    await this.laborService.getChargingGroupDropDown().then((response) => {
      this.spinner.hide()
      this.chargingGroupList = response.responseObject;
      if(this.chargingGroupList != null && this.chargingGroupList.length > 0){
        let defaultValueGroupChargingCode = this.ServiceInfo.serviceDetails[0].dmsChargingGroup;
        if(defaultValueGroupChargingCode.length > 0 ){
          this.editServiceForm.patchValue({
            chargingGroup : defaultValueGroupChargingCode
          })
        }
      }
    }, _error => {
      this.spinner.hide()
    });
  }
}
